import clsx from 'clsx';

import { FileName } from '~components/generic/filename/FileName';
import { Spinner } from '~components/generic/spinner/Spinner';
import { DownloadIcon, FolderSymlinkIcon, ThumbnailIcon } from '~components/icons';
import useLabels from '~hooks/useLabels';
import styles from './ModuleAttachments.module.css';

type AssetProps = {
  isSharingEnabled?: boolean;
  onShare?: () => void;
  filename: string;
  previewUrl?: string;
  onDownload?: () => void;
  downloadLoading?: boolean;
  shareLoading?: boolean;
  showAddToMyFiles?: boolean;
};

export const Asset = ({
  isSharingEnabled,
  onShare,
  filename,
  onDownload,
  downloadLoading,
  shareLoading,
  previewUrl,
  showAddToMyFiles,
}: AssetProps) => {
  const { msgNoPreviewAvailable, linkTitleAddMyfiles, linkTitleDownload } = useLabels([
    'msgNoPreviewAvailable',
    'linkTitleAddMyfiles',
    'linkTitleDownload',
  ]);

  return (
    <li className={clsx(styles.listItem, 'asset-listitem')}>
      <div className={clsx(styles.listItemContent, 'asset-listitem--content')}>
        <div
          className={clsx(styles.thumbnail, 'asset-listitem--thumbnail')}
          title={!previewUrl ? msgNoPreviewAvailable : undefined}
        >
          {previewUrl ? (
            <img src={previewUrl} alt="" className={clsx(styles.thumbnailImg, 'asset-listitem--thumbnail-img')} />
          ) : (
            <ThumbnailIcon />
          )}
        </div>
        <div className={clsx(styles.name, 'asset-listitem--name')}>
          <FileName filename={filename} characters={30} />
        </div>
        {!!isSharingEnabled && showAddToMyFiles && (
          <div
            className={clsx(styles.button, 'asset-listitem--button')}
            title={linkTitleAddMyfiles}
            onClick={() => onShare?.()}
          >
            {shareLoading ? (
              <Spinner className={clsx(styles.buttonSpinner, 'asset-listitem--button-spinner')} />
            ) : (
              <div className={clsx(styles.buttonIcon, 'asset-listitem--button-icon')}>
                <FolderSymlinkIcon />
              </div>
            )}
          </div>
        )}
        <div
          className={clsx(styles.button, 'asset-listitem--button')}
          title={linkTitleDownload}
          onClick={() => onDownload?.()}
        >
          {downloadLoading ? (
            <Spinner className={clsx(styles.buttonSpinner, 'asset-listitem--button-spinner')} />
          ) : (
            <div className={clsx(styles.buttonIcon, 'asset-listitem--button-icon')}>
              <DownloadIcon />
            </div>
          )}
        </div>
      </div>
    </li>
  );
};
